// Single source of truth for the reduced-motion preference, read once at load.
// Mirrors the design target's module-scope `RM` guard.
export const RM =
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
